export default {
  dataInicial: {
    value: '',
    required: false,
    state: null
  },
  mensagemForaHorario: {
    value: '',
    required: true,
    state: null
  },
  mensagemBoasVindas: {
    value: '',
    required: true,
    state: null
  },
  mensagemAssumir: {
    value: '',
    required: true,
    state: null
  },
  mensagemTransferir: {
    value: '',
    required: true,
    state: null
  },
  mensagemFinalizar: {
    value: '',
    required: true,
    state: null
  },
  mensagemNps: {
    value: '',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/parametros_atendimento/mensagensautomaticas/components/add/mensagensautomaticasadd-form.js